mutation UpdateFundsDafPlan($input: UpdateFundsDafPlanInput!) {
  updateFundsDafPlan(input: $input) {
    success
  }
}
